import {
    List, Datagrid, TextField, DateField, Show, ShowButton, SearchInput, Filter,
    TopToolbar, ListActions, useRecordContext
} from "react-admin";
import React from "react";
import { Box, Typography } from "@mui/material";
import PaymentMonthScreen from "../components/paymentMonthScreen";
import GenerateMonthButton from "../components/generatePaymentMonth";

const PeriodFilter = (props) => (
    <Filter {...props} alwaysOn>
        <SearchInput source="label" alwaysOn />
    </Filter>
);

// The month list is the picker. Months are data rather than routes, so the
// sidebar stays one Payments entry no matter how many months exist.
//
// react-admin renders the empty state instead of the list when there is nothing
// yet, and the empty state has no toolbar - so the Generate button is put here,
// or there would be no way to make the first month.
const PaymentsEmpty = () => (
    <Box sx={{ textAlign: 'center', py: 8 }}>
        <Typography variant="h6" gutterBottom>No payment months yet</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
            Generate one from the standing allowances. Beneficiaries need a monthly allowance and an account holder before a month can include them.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <GenerateMonthButton />
        </Box>
    </Box>
);

const list = props => (
    <List perPage={50} filters={<PeriodFilter />} {...props}
        actions={<TopToolbar><ListActions /><GenerateMonthButton /></TopToolbar>}
        empty={<PaymentsEmpty />}
        sort={{ field: 'month', order: 'DESC' }}>
        <Datagrid rowClick="show">
            <TextField source="label" />
            <TextField source="month" />
            <TextField source="status" />
            <DateField source="approvedAt" />
            <DateField source="paidAt" />
            <ShowButton />
        </Datagrid>
    </List>
);

const MonthSummary = () => {
    return (
        <>
            <TextField source="label" />
            <TextField source="month" />
            <TextField source="status" />
            <DateField source="approvedAt" />
            <DateField source="paidAt" />
        </>
    );
};

// The show route knows the id; the tick list is addressed by month. Bridging the
// two through the loaded record avoids a custom route for a screen that is
// always reached from the month list anyway.
const TickList = () => {
    const record = useRecordContext();
    if (!record) return null;
    return <PaymentMonthScreen month={record.month} status={record.status} />;
};

const show = props => (
    <Show {...props} queryOptions={{ refetchOnMount: true }}>
        <Datagrid bulkActionButtons={false} rowClick={false}>
            <MonthSummary />
        </Datagrid>
        <TickList />
    </Show>
);

const PaymentPeriod ={ list, show };

export default PaymentPeriod;